//
// 题型，''01''单选，''02''多选，''03''不定项，''05''主观题
export const ENUM_KIND_MAP = {
  SINGLE_CHOICE:'01',
  MULTIPLE_CHOICE:'02',
  INDEFINITE_TERM:'03',
  SUBJECTIVE_QUESTIONS:'05' // 主观题
}
export const QUESTION_TYPE = {
  '01': '单项选择题',
  '02': '多项选择题',
  '03': '不定项选择题',
  '04': '速记刷题',
  '05': '主观题',
  '06': '背诵',
  99: '案例分析题'
}
// 题型，''01''单选，''02''多选，''03''不定项，''05''主观题

// 用来区分场景的唯一一标识
export const EXAM_TYPE = 'examType'
// 考试类型
export const EnumExamType = {
  MOCK: 2  // 模考
}
export const ENUM_BUSINESS_TYPE={
  FA_SHUO:90,
  FA_KAO:104
}

